export default [
  {
    path: '',
    component: () => import('@/layouts/main/User.vue'),
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: { name: 'dashboard.registration_status' },
        component: () => import('@/views/User/Dashboard.vue'),
        children: [
          {
            path: 'registration-status',
            name: 'dashboard.registration_status',
            component: () => import('@/views/User/Dashboard/RegistrationStatus.vue')
          },
          {
            path: 'announcements',
            name: 'dashboard.announcements',
            component: () => import('@/views/User/Dashboard/Announcements.vue')
          }
        ]
      },
      {
        path: '/configuration',
        name: 'configuration',
        redirect: { name: 'configuration.members.groups' },
        component: () => import('@/views/User/Configuration.vue'),
        children: [
          {
            path: 'caller-id',
            name: 'configuration.caller_id',
            component: () => import('@/views/User/Configuration/CallerId.vue')
          },
          {
            path: 'members',
            name: 'configuration.members',
            redirect: { name: 'configuration.members.groups' },
            component: () => import('@/views/User/Configuration/Member.vue'),
            children: [
              {
                path: 'groups',
                name: 'configuration.members.groups',
                component: () => import('@/views/User/Configuration/Member/Groups.vue')
              },
              {
                path: 'levels',
                name: 'configuration.members.levels',
                component: () => import('@/views/User/Configuration/Member/Levels.vue')
              },
              {
                path: 'custom-fields',
                name: 'configuration.members.custom_fields',
                component: () => import('@/views/User/Configuration/Member/CustomFields.vue')
              }
            ]
          },
          {
            path: 'consultation',
            name: 'configuration.consultation',
            redirect: { name: 'configuration.consultation.inquiry' },
            component: () => import('@/views/User/Configuration/Consultation.vue'),
            children: [
              {
                path: 'inquiry',
                name: 'configuration.consultation.inquiry',
                component: () => import('@/views/User/Configuration/Consultation/Inquiry.vue')
              },
              {
                path: 'department',
                name: 'configuration.consultation.department',
                component: () => import('@/views/User/Configuration/Consultation/Departments.vue')
              },
              {
                path: 'big',
                name: 'configuration.consultation.big',
                component: () => import('@/views/User/Configuration/Consultation/Bigs.vue')
              },
              {
                path: 'small',
                name: 'configuration.consultation.small',
                component: () => import('@/views/User/Configuration/Consultation/Smalls.vue')
              },
              {
                path: 'custom-fields',
                name: 'configuration.consultation.custom_fields',
                component: () => import('@/views/User/Configuration/Consultation/CustomFields.vue')
              }
            ]
          },
          {
            path: 'inbound',
            name: 'configuration.inbound',
            redirect: { name: 'configuration.inbound.ringGroup' },
            component: () => import('@/views/User/Configuration/Inbound.vue'),
            children: [
              {
                path: 'ring-group',
                name: 'configuration.inbound.ringGroup',
                component: () => import('@/views/User/Configuration/Inbound/RingGroup.vue')
              },
              {
                path: 'callback-group',
                name: 'configuration.inbound.callbackGroup',
                component: () => import('@/views/User/Configuration/Inbound/CallbackGroup.vue')
              },
              {
                path: 'ivr',
                name: 'configuration.inbound.ivr',
                component: () => import('@/views/User/Configuration/Inbound/Ivrs.vue')
              }
            ]
          },
          {
            path: 'task',
            name: 'configuration.task',
            redirect: { name: 'configuration.task.category' },
            component: () => import('@/views/User/Configuration/Task.vue'),
            children: [
              {
                path: 'category',
                name: 'configuration.task.category',
                component: () => import('@/views/User/Configuration/Task/Categories.vue')
              }
            ]
          },
          {
            path: 'custom-tables',
            name: 'configuration.custom_tables',
            redirect: { name: 'configuration.custom_tables.member' },
            component: () => import('@/views/User/Configuration/CustomTable.vue'),
            children: [
              {
                path: 'members',
                name: 'configuration.custom_tables.members',
                component: () => import('@/views/User/Configuration/CustomTable/Members.vue')
              },
              {
                path: 'consultations',
                name: 'configuration.custom_tables.consultations',
                component: () => import('@/views/User/Configuration/CustomTable/Consultations.vue')
              },
              {
                path: 'inbound-details',
                name: 'configuration.custom_tables.inbound-details',
                component: () => import('@/views/User/Configuration/CustomTable/InboundDetails.vue')
              },
              {
                path: 'outbound-details',
                name: 'configuration.custom_tables.outbound-details',
                component: () => import('@/views/User/Configuration/CustomTable/OutboundDetails.vue')
              }
            ]
          }
        ]
      },
      {
        path: '/slogan',
        name: 'slogan.manage',
        component: () => import('@/views/User/Slogan.vue')
      },
      {
        path: '/users',
        name: 'user.manage',
        component: () => import('@/views/User/Users.vue')
      },
      {
        path: '/consultations',
        name: 'consultations',
        component: () => import('@/views/User/Consultations.vue'),
        redirect: { name: 'consultations.consultations' },
        children: [
          {
            path: 'consultations',
            name: 'consultations.consultations',
            component: () => import('@/views/User/Consultations/Consultations.vue')
          },
          {
            path: 'callbacks',
            name: 'consultations.callbacks',
            component: () => import('@/views/User/Consultations/Callback.vue')
          },
          {
            path: 'import',
            name: 'consultations.import',
            component: () => import('@/views/User/Consultations/ConsultationImport.vue')
          }
        ]
      },
      {
        path: '/members',
        name: 'members',
        component: () => import('@/views/User/Members.vue')
      },
      {
        path: '/member/import',
        name: 'member.import',
        component: () => import('@/views/User/Members/MemberImport.vue')
      },
      {
        path: '/tasks',
        name: 'tasks',
        component: () => import('@/views/User/Tasks.vue')
      },
      {
        path: '/projects',
        name: 'projects',
        component: () => import('@/views/User/Projects.vue')
      },
      {
        path: '/messages',
        name: 'messages',
        component: () => import('@/views/User/Messages.vue'),
        redirect: { name: 'messages' },
        children: [
          {
            path: 'history',
            name: 'messages.history',
            component: () => import('@/views/User/Messages/History.vue')
          },
          {
            path: 'category',
            name: 'messages.category',
            component: () => import('@/views/User/Messages/Category.vue')
          },
          {
            path: 'callback-number',
            name: 'messages.callbackNumber',
            component: () => import('@/views/User/Messages/CallbackNumber.vue')
          },
          {
            path: 'template',
            name: 'messages.template',
            component: () => import('@/views/User/Messages/Templates.vue')
          }
        ]
      },
      {
        path: '/my-account',
        name: 'my-account',
        component: () => import('@/views/User/MyAccount.vue'),
        redirect: { name: 'my-account.personal-information' },
        children: [
          {
            path: 'personal-information',
            name: 'my-account.personal-information',
            component: () => import('@/views/User/MyAccount/PersonalInformation.vue')
          },
          {
            path: 'change-password',
            name: 'my-account.change-password',
            component: () => import('@/views/User/MyAccount/ChangePassword.vue')
          }
        ]
      },
      {
        path: '/fax',
        name: 'fax',
        component: () => import('@/views/User/Fax.vue')
      },
      {
        path: '/queues',
        name: 'queues',
        component: () => import('@/views/User/Queues.vue')
      },
      {
        path: '/time-conditions',
        name: 'time-conditions',
        component: () => import('@/views/User/TimeConditions.vue')
      },
      {
        path: '/transfers',
        name: 'transfers',
        component: () => import('@/views/User/Transfers.vue')
      },
      {
        path: '/call-statistics',
        name: 'call-statistics',
        component: () => import('@/views/User/CallStatistics.vue'),
        redirect: { name: 'callStatistics.inboundDetails' },
        children: [
          {
            path: 'inbound-details',
            name: 'callStatistics.inboundDetails',
            component: () => import('@/views/User/CallStatistics/InboundDetails.vue')
          },
          {
            path: 'outbound-details',
            name: 'callStatistics.outboundDetails',
            component: () => import('@/views/User/CallStatistics/OutboundDetails.vue')
          },
          {
            path: 'inbound-statistics',
            name: 'callStatistics.inboundStatistics',
            component: () => import('@/views/User/CallStatistics/InboundStatistics.vue')
          },
          {
            path: 'call-statistics',
            name: 'callStatistics.callStatistics',
            component: () => import('@/views/User/CallStatistics/CallStatistics.vue')
          },
          {
            path: 'extension-status-data-analysis',
            name: 'callStatistics.extension-status-data-analysis',
            component: () => import('@/views/User/CallStatistics/ExtensionStatusDataAnalysis.vue')
          }
        ]
      },
      {
        path: '/message-management',
        name: 'message-management',
        component: () => import('@/views/User/MessageManagement.vue'),
        redirect: { name: 'messageManagement.sentHistory' },
        children: [
          {
            path: 'sent-history',
            name: 'messageManagement.sentHistory',
            component: () => import('@/views/User/MessageManagement/SentHistory.vue')
          },
          {
            path: 'received-history',
            name: 'messageManagement.receivedHistory',
            component: () => import('@/views/User/MessageManagement/ReceivedHistory.vue')
          }
        ]
      },
      // {
      //   path: '/message-management',
      //   name: 'message-management',
      //   component: () => import('@/views/User/MessageManagement/SentHistory.vue')
      // },
      {
        path: '/schedules',
        name: 'schedules',
        component: () => import('@/views/User/Schedules.vue')
      },
      {
        path: '/upload-sound-file',
        name: 'upload-sound-file',
        component: () => import('@/views/User/UploadSoundFile.vue')
      },
      {
        path: '/auto-call-system',
        name: 'auto-call-system',
        component: () => import('@/views/User/AutoCallSystem.vue')
      },
      {
        path: '/auto-call-system/public',
        name: 'auto-call-system-public',
        component: () => import('@/views/User/AutoCallSystemPublic.vue')
      },
      {
        path: '/agent-api-key',
        name: 'agent-api-key',
        component: () => import('@/views/User/AgentApiKey.vue')
      },
      {
        path: '/branch-extension',
        name: 'branch-extension',
        component: () => import('@/views/User/BranchExtension.vue')
      },
      {
        path: '/blacklist',
        name: 'blacklist',
        component: () => import('@/views/User/Blacklist.vue')
      }
    ]
  }
]
